import React, { useEffect } from 'react'
import commonStyles from "../../AddPayerCommonStyles.styles"
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown'
import TextInput from '../../../../../components/input/textinput/TextInput'
import Heading from '../../../../../components/heading/Heading'
import { HEADING } from '../../../../../components/heading/constants/constants'
import styles from "./GetAddressInfo.styles"
import { componentKey, setAddressInformation, setZipCodeValidationSuccess } from '../../AddPayerSlice'
import { useDispatch, useSelector } from 'react-redux'
import { validateZipCode } from '../../AddPayerSaga'
import { generalValidator } from '../../../../../../libs/utility/validators/GeneralValidator'
import { componentKey as dataLoaderKey } from '../../../../loaders/dataloader/DataLoaderSlice';
import { getCountriesAndStatesList } from '../../../../loaders/dataloader/DataLoaderSaga'
import { componentKey as authenticationKey } from '../../../../authentication/AuthenticationSlice'
import General from '../../../../../../libs/utility/General'
import Loadable from '../../../../../components/loadable/Loadable'
import { ADD_PAYER_LOADING_MESSAGE_MAP, ADD_PAYER_LOADING_STATES } from '../../constant'

export default function GetAddressInfo() {

    const { signedInUser } = useSelector(state => state[authenticationKey]);
    const { countriesList, statesList } = useSelector((state) => state[dataLoaderKey]);

    const { addressInformation, basicInfo, loadingState } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();

    const onChangehandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(setAddressInformation({ [name]: { value, errors, rules } }));
        } else {
            dispatch(setAddressInformation({ [name]: { value } }));
        }
    };

    useEffect(() => {
        if (countriesList.length <= 0 || statesList.length <= 0) {
            dispatch(getCountriesAndStatesList())
        };
    }, [])

    const payerName = basicInfo?.PayerFirstName?.value || basicInfo?.PayerLastName?.value || "";
    const zipCode = General.formatZipCode(addressInformation.PayerZIP?.value)

    return (
        <>
            <div style={commonStyles.container}>
                <div>
                    <Heading type={HEADING.H1}>{`What is ${General.formatNameAsPossessive(payerName)} address?`}</Heading>
                </div>

                <div style={commonStyles.formContainer}>
                <div style={styles.formRow}>
                <div style={styles.fieldContainer}>
                    <TextInput
                        name="PayerAddress"
                        label="Street Address (including apartment number)"
                        placeHolder='Enter street address'
                        value={addressInformation.PayerAddress?.value}
                        onChangeCb={onChangehandler}
                        rules={addressInformation.PayerAddress?.rules}
                        errors={addressInformation.PayerAddress?.errors}
                        formSubmitted={addressInformation.allRequiredFieldsTouched}
                    />
                    </div>
                    <div style={styles.stateContainer}>
                    <TextInput
                        name="PayerAddress2"
                        label="Address line 2"
                        placeHolder='Enter address'
                        value={addressInformation.PayerAddress2?.value}
                        rules={addressInformation.PayerAddress2?.rules}
                        errors={addressInformation.PayerAddress2?.errors}
                        onChangeCb={onChangehandler}
                    />
                    </div>
                    </div>

                    <div style={styles.formRow}>
                        <div style={styles.fieldContainer}>
                            <SelectDropdown
                                label="Country"
                                placeHolder="Enter country"
                                name="PayerCountry"
                                value={{ label: addressInformation.PayerCountry.label, value: addressInformation.PayerCountry.value }}
                                onSelectCb={(name, selectedOption) => dispatch(setAddressInformation({ [name]: selectedOption }))}
                                options={countriesList}
                                rules={addressInformation.PayerCountry?.rules}
                                errors={addressInformation.PayerCountry?.errors}
                                formSubmitted={addressInformation.allRequiredFieldsTouched}
                            />
                        </div>
                        <div style={styles.stateContainer}>
                            {addressInformation.PayerCountry.value === "US" ?
                                <SelectDropdown
                                    label="State"
                                    placeHolder="Enter state"
                                    name="PayerState"
                                    value={addressInformation.PayerState}
                                    onSelectCb={(name, selectedOption) => dispatch(setAddressInformation({ [name]: selectedOption }))}
                                    options={statesList}
                                    rules={addressInformation.PayerState?.rules}
                                    errors={addressInformation.PayerState?.errors}
                                    formSubmitted={addressInformation.allRequiredFieldsTouched}
                                />

                                :

                                <TextInput
                                    label="State"
                                    placeHolder='Enter state name'
                                    name="PayerState"
                                    value={addressInformation.PayerState.label}
                                    onChangeCb={(e) => dispatch(setAddressInformation({ [e.target.name]: { label: e.target.value, value: e.target.value } }))}
                                    rules={addressInformation.PayerState?.rules}
                                    errors={addressInformation.PayerState?.errors}
                                    formSubmitted={addressInformation.allRequiredFieldsTouched}
                                />}
                        </div>
                    </div>

                    <div style={styles.formRow}>
                        <div style={styles.fieldContainer}>
                            <Loadable currentState={loadingState.state} loadingStates={[ADD_PAYER_LOADING_STATES.VALIDATE_ZIP_CODE_LOADING]} isNewLoadable={true} messageMap={ADD_PAYER_LOADING_MESSAGE_MAP}>
                                <TextInput
                                    name="PayerZIP"
                                    label="ZIP code"
                                    placeHolder='Enter Zip Code'
                                    value={zipCode}
                                    onChangeCb={onChangehandler}
                                    onBlurCb={() => dispatch(validateZipCode(addressInformation))}
                                    rules={addressInformation.PayerZIP?.rules}
                                    errors={addressInformation.PayerZIP?.errors}
                                    formSubmitted={addressInformation.allRequiredFieldsTouched}
                                />
                            </Loadable>
                        </div>
                        <div style={styles.stateContainer}>
                            <TextInput
                                name="PayerCity"
                                label="City"
                                placeHolder='Enter city name'
                                value={addressInformation.PayerCity?.value}
                                onChangeCb={onChangehandler}
                                rules={addressInformation.PayerCity?.rules}
                                errors={addressInformation.PayerCity?.errors}
                                formSubmitted={addressInformation.allRequiredFieldsTouched}
                            />
                        </div>
                    </div>

                </div>
            </div >
        </>
    )
}